// i18next-extract-mark-ns-start Testimonials
import React from 'react';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { GatsbyImage } from 'gatsby-plugin-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

function Wrap({ children, length }) {
  return (
    <div>
      <CarouselProvider
        naturalSlideWidth={150}
        naturalSlideHeight={240}
        totalSlides={length}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={5000}
        className="sm:hidden"
        isIntrinsicHeight={false}
      >
        {children}
      </CarouselProvider>
      <CarouselProvider
        naturalSlideWidth={150}
        naturalSlideHeight={120}
        totalSlides={length}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={5000}
        className="hidden sm:block md:hidden"
        isIntrinsicHeight={false}
      >
        {children}
      </CarouselProvider>
      <CarouselProvider
        naturalSlideWidth={150}
        naturalSlideHeight={110}
        totalSlides={length}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={5000}
        className="hidden md:block lg:hidden"
        isIntrinsicHeight={false}
      >
        {children}
      </CarouselProvider>
      <CarouselProvider
        naturalSlideWidth={200}
        naturalSlideHeight={77}
        totalSlides={5}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={5000}
        className="hidden lg:block xl:hidden"
        isIntrinsicHeight={false}
      >
        {children}
      </CarouselProvider>
      <CarouselProvider
        naturalSlideWidth={200}
        naturalSlideHeight={77}
        totalSlides={5}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={5000}
        className="hidden xl:block"
        isIntrinsicHeight={false}
      >
        {children}
      </CarouselProvider>
    </div>
  );
}

class Testimonials extends React.Component {
  render() {
    return (
      <Wrap length={this.props.slides.length}>
        <div className="relative m-auto">
          <Slider className="relative">
            {this.props.slides.map((item, index) => (
              <Slide key={index} index={item.index}>
                <section className="relative isolate overflow-hidden bg-white py-16 px-6 lg:px-8">
                  <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20" />
                  <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center" />
                  <div className="mx-auto max-w-lg md:max-w-xl lg:max-w-3xl xl:max-w-4xl">
                    {item && item.logo && item.logo.childImageSharp ? (
                      <GatsbyImage
                        objectFit="cover"
                        className="mx-auto"
                        image={item.logo.childImageSharp.gatsbyImageData}
                        imgClassName="w-48 h-12"
                      />
                    ) : null}
                    <figure className="mt-10">
                      <blockquote className="text-justify text-sm font-semibold leading-8 text-gray-900 md:text-lg sm:leading-9">
                        {item.text}
                      </blockquote>
                      <figcaption className="mt-10">
                        <GatsbyImage
                          objectFit="cover"
                          className="mx-auto rounded-full"
                          style={{ width: '5rem', height: '5rem' }}
                          image={item.image.childImageSharp.gatsbyImageData}
                        />
                        <div className="mt-4 flex items-center justify-center space-x-3 text-base">
                          <div className="font-semibold text-gray-900">
                            {item.person}
                          </div>
                          <svg
                            viewBox="0 0 2 2"
                            width={3}
                            height={3}
                            aria-hidden="true"
                            className="fill-gray-900"
                          >
                            <circle cx={1} cy={1} r={1} />
                          </svg>
                          <div className="text-gray-600">{item.role}</div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </section>
              </Slide>
            ))}
          </Slider>
          <ButtonBack className="hidden md:block absolute top-64 left-8 text-2xl text-dark-grey px-2 py-1">
            <FontAwesomeIcon icon={faChevronLeft} />
          </ButtonBack>
          <ButtonNext className="hidden md:block absolute top-64 right-8 text-2xl text-dark-grey px-2 py-1">
            <FontAwesomeIcon icon={faChevronRight} />
          </ButtonNext>
        </div>
      </Wrap>
    );
  }
}

Testimonials.displayName = 'Testimonials';

export default Testimonials;
